import React from 'react';
import { Chip } from '@mui/material';

export const getServiceColor = (serviceType) => {
    switch (serviceType) {
        case 'Transfer':
            return 'info';
        case 'Chauffeur':
            return 'secondary';
        case 'Rental':
        default:
            return 'primary';
    }
};

export const ServiceChip = ({ serviceType = 'Rental', size = 'small', variant = 'outlined', sx = {} }) => {
    const type = serviceType || 'Rental';
    const color = getServiceColor(type);
    return (
        <Chip
            label={type}
            size={size}
            color={color}
            variant={variant}
            sx={{ fontWeight: 500, ...sx }}
        />
    );
};

export default ServiceChip;
